import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const Activity = ({ date, activity, today }) => {
  const useStyles = makeStyles((theme) => ({
    container: {
      background: today ? '#1E91A6' : 'rgba(30,145,166, 0.1)',
      color: today ? '#FFF' : '#3A3A3A',

      marginTop: '10px',
      padding: '10px'
    },
    date: {
      fontSize: '14px',
      fontWeight: 'bold'
    },
    activity: {
      fontSize: '14px'
    }
  }));

  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h3 className={classes.date}>{date}</h3>
      <p className={classes.activity}>{activity}</p>
    </div>
  );
};

export default Activity;
